module.exports = __webpack_public_path__ + "static/media/doom_of_egypt.playngo.930e7d53.jpeg";